export default "__VITE_ASSET__9jAZgHv4__"